import { useState } from "react";

import { QueryResult } from "../../../types/responses";
import { usePageSize } from "./usePageSize";

export const usePageNavigation = () => {
	const [pageIndex, setPageIndex] = useState(0);
	const [pageSize, setPageSize] = usePageSize();
	const [totalPages, setTotalPages] = useState(1);
	const [fetchedCount, setFetchedCount] = useState(20);
	const [totalAvailable, setTotalAvailable] = useState(20);

	const goToPage = (page: number) => {
		setPageIndex(Math.max(0, Math.min(page, totalPages - 1)));
	};

	const nextPage = () => {
		if (pageIndex <= totalPages) {
			setPageIndex(pageIndex + 1);
		}
	};

	const previousPage = () => {
		if (pageIndex > 0) {
			setPageIndex(pageIndex - 1);
		}
	};

	const resetToFirstPage = () => {
		setPageIndex(0);
	};

	const setFromQueryData = (queryData: QueryResult) => {
		setPageIndex(queryData.paginationMetadata.pageNo - 1);
		setTotalPages(queryData.paginationMetadata.totalPages);
		// Tolerate both shapes: a pre-nesting backend returns these at the root, not
		// inside paginationMetadata. Without this the footer counts render blank.
		setFetchedCount(
			queryData.paginationMetadata.fetchedCount ?? queryData.fetchedCount ?? 0
		);
		setTotalAvailable(
			queryData.paginationMetadata.totalAvailable ?? queryData.totalAvailable ?? 0
		);
	};

	return {
		pageIndex,
		pageNo: pageIndex + 1,
		pageSize,
		setTotalPages,
		setPageSize,
		goToPage,
		nextPage,
		setFromQueryData,
		previousPage,
		resetToFirstPage,
		fetchedCount,
		setFetchedCount,
		totalAvailable,
		setTotalAvailable,
		canNextPage: pageIndex < totalPages - 1,
		canPreviousPage: pageIndex > 0,
		totalPages,
	};
};
